import request from '@/utils/request'

/* 集团租户列表 */
export function tenantList(data) {
  return request({
    url: '/admin/v1/vehicle/tenant/list',
    method: 'POST',
    data,
  })
}

/* 关联网约车租户列表 */
export function tenantMappingList(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/5327',
    url: '/admin/v1/vehicle/tenant/mappingList',
    method: 'POST',
    data,
  })
}
/* 禁用/启用状态更新接口 */
export function tenantUpdate(data) {
  return request({
    url: '/admin/v1/vehicle/tenant/updateState',
    method: 'POST',
    data,
  })
}

/* 编辑租户 */
export function tenantEdit(data) {
  return request({
    url: '/admin/v1/vehicle/tenant/edit',
    method: 'POST',
    data,
  })
}

/* 新增租户 */
export function tenantAdd(data) {
  return request({
    url: '/admin/v1/vehicle/tenant/add',
    method: 'POST',
    data,
  })
}

/* 用户列表 */
export function userList(data) {
  return request({
    url: '/admin/v1/vehicle/user/manage/hubble/userList',
    method: 'POST',
    data,
  })
}

/* 编辑用户 */
export function userEdit(data) {
  return request({
    url: '/admin/v1/vehicle/user/manage/hubble/editUser',
    method: 'POST',
    data,
  })
}
/* 用户修改密码 */
export function resetPassword(data) {
  return request({
    url: '/admin/v1/vehicle/user/manage/hubble/resetPassword',
    method: 'POST',
    data,
  })
}
/* 获取全部资源树 */
export function allTree(data = {}) {
  return request({
    url: '/admin/v1/vehicle/user/resource/allTree',
    method: 'POST',
    data,
  })
}
/* 更新资源可见度 */
export function setAffordance(data) {
  return request({
    url: '/admin/v1/vehicle/user/resource/setAffordance',
    method: 'POST',
    data,
  })
}
/* 添加菜单 */
export function allocationAdd(data) {
  return request({
    url: '/admin/v1/vehicle/user/resource/add',
    method: 'POST',
    data,
  })
}
/* 修改菜单 */
export function allocationEdit(data) {
  return request({
    url: '/admin/v1/vehicle/user/resource/edit',
    method: 'POST',
    data,
  })
}

// 校验资源重复
export function getUserResourceCheck(data) {
  return request({
    url: '/admin/v1/vehicle/user/resource/check',
    method: 'POST',
    data,
  })
}
// 公司信息列表查询接口
export function companyList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/list',
    method: 'POST',
    data,
  })
}
// 查询配置列表
export function configList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/common/config/list',
    method: 'POST',
    data,
  })
}
// 启动或停止配置开关接口
export function updateStateConfig(data = {}) {
  return request({
    url: '/admin/v1/vehicle/common/config/updateState',
    method: 'POST',
    data,
  })
}
// 启动或停止配置开关接口
export function configEdit(data = {}) {
  return request({
    url: '/admin/v1/vehicle/common/config/edit',
    method: 'POST',
    data,
  })
}
// 获取产权方列表
export function getConfigProviderList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/common/config/providerList',
    method: 'POST',
    data,
  })
}

// 钉钉审批流列表
export function dingTalkList(data = {}) {
  return request({
    url: '/admin/v1/approval/dingtalkOrganization/page',
    method: 'POST',
    data,
  })
}

// 启用/禁用 钉钉组织
export function enableStartDingTalk(data = {}) {
  return request({
    url: '/admin/v1/approval/dingtalkOrganization/update',
    method: 'POST',
    data,
  })
}

// 编辑钉钉组织
export function editDingTalkOrganization(data = {}) {
  return request({
    url: '/admin/v1/approval/dingtalkOrganization/edit',
    method: 'POST',
    data,
  })
}

// 新增钉钉组织
export function addDingTalkOrganization(data = {}) {
  return request({
    url: '/admin/v1/approval/dingtalkOrganization/add',
    method: 'POST',
    data,
  })
}
// 获取已经绑定组织的公司 /admin/v1/approval/dingtalkOrganization/removeRelationedCompany
export function getBindCompany(data = {}) {
  return request({
    url: '/admin/v1/approval/dingtalkOrganization/getAvailableCompany',
    method: 'POST',
    data,
  })
}

